<script lang="ts">
	// Import common notifications component
	import Notifications from 'src/components/Sidepanel/SidePanelLayoutProvider/SidePanelDeviceLayout/CommonDeviceTabs/Notifications.svelte';
</script>

<Notifications />
